import PropTypes from 'prop-types';
import { find, path, propEq } from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import React, { Component } from 'react';

import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import grey from '@material-ui/core/es/colors/grey';
import { DirectionsBus } from '@material-ui/icons';

import { readEndpointDedup } from '../../modules/reducers/api';

const styles = {
  message: {
    name: {
      color: 'rgba(0, 0, 0, 0.87)', // darkBlack from material-ui
    },
  },
  datetime: {
    fontSize: 12,
    color: grey[700],
  },
};


class ReservedVehicleMessage extends Component {
  static propTypes = {
    // own props
    message: PropTypes.shape({
      type: PropTypes.oneOf(['dashboard-message']).isRequired,
      id: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        'sender-type-name': PropTypes.oneOf(['reserved-vehicle']).isRequired,
        'sender-id': PropTypes.number.isRequired,
        'payload': PropTypes.shape({
          'route-blockage': PropTypes.number.isRequired,
          'vehicle': PropTypes.number.isRequired,
          'company': PropTypes.number.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
    routeBlockageNames: PropTypes.shape({}).isRequired,

    // state props
    company: PropTypes.shape({}),
    companyId: PropTypes.string.isRequired,
    routeBlockageId: PropTypes.string.isRequired,

    // dispatch props
    readEndpointDedup: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { companyId, company, readEndpointDedup } = this.props;

    if (!company) readEndpointDedup(`company/${companyId}`);
  };

  shouldComponentUpdate(nextProps, nextState) {
    // Only update if a previously unavailable company has loaded.
    if (!this.props.company && nextProps.company) return true;

    return false;
  };

  render() {
    const { message, routeBlockageNames, routeBlockageId, companyId, company } = this.props;

    if (!company) return (<ListItem insetChildren={true} primaryText="Laden..." />);

    const routeBlockageName = routeBlockageNames[routeBlockageId] || 'Onbekend';
    const companyName = path(['attributes', 'name'], company) || 'Onbekend';
    const datetime = new Date(path(['attributes', 'created-at'], message));

    switch (message.attributes.action) {
      case 'CREATE': {
        let title = '1 bus gekoppeld';

        if (message.attributes.merged)
          title = message.attributes['sender-ids'].length + ' bussen gekoppeld';

        return (
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Avatar>
                <DirectionsBus />
              </Avatar>
            </ListItemAvatar>

            <ListItemText
              primary={
                <span>
                  {title}<br />
                  <span style={styles.datetime}>{datetime.toLocaleString()}</span>
                </span>
              }
              secondary={
                <span style={{ margin: 0 }}>
                  <span style={styles.message.name}>{companyName}</span> --
                  Op stremming `{routeBlockageName}`.
                </span>
              }
            />
          </ListItem>
        );
      }
      default: {
        return null;
      }
    }
  };
}


const selectRouteBlockageId = (_, ownProps) => (String(path(['message', 'attributes', 'payload', 'route-blockage'], ownProps)));
const selectCompanyId = (_, ownProps) => (String(path(['message', 'attributes', 'payload', 'company'], ownProps)));
const selectCompanies = state => path(['api', 'company', 'data'], state) || [];
const getCompany = createSelector([selectCompanyId, selectCompanies], (cid, cs) => {
  return find(propEq('id', cid))(cs);
});

const mapStateToProps = (state, ownProps) => ({
  company: getCompany(state, ownProps),
  companyId: selectCompanyId(state, ownProps),
  routeBlockageId: selectRouteBlockageId(state, ownProps),
});

const mapDispatchToProps = {
  readEndpointDedup
};

export default connect(mapStateToProps, mapDispatchToProps)(ReservedVehicleMessage);
